import { configureStore } from '@reduxjs/toolkit';
import { userReducer } from './slices/user.slice';
import { appReducer } from './slices/app.slice';
import { gameReducer } from './slices/game.slice';
import { serviceReducer } from './slices/service.slice';

export const store = configureStore({
  reducer: {
    app: appReducer,
    user: userReducer,
    game: gameReducer,
    service: serviceReducer,
  },
});
